export {
  Autotrader as default,
  getStaticProps,
} from '@cinch-nx/feature-autotrader'
